var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',[_c('div',{staticClass:"footer_links"},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Правила")])]),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Команда проекта")])]),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Обратная связь")])])])])])])
}]

export { render, staticRenderFns }